import { server } from "../api";
import axios from "axios";
export default {
  Initialize: async (IP, port) => {
    try {
      let response = await axios.get(`http://${IP}:${port}/init_stat`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetData: async (IP, port) => {
    try {
      let response = await axios.get(`http://${IP}:${port}/get_stat`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetChartData: async (id, days) => {
    try {
      const response = await axios.get(`${server}monitor/data`, {
        params: { id, days },
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetBounds: async (id) => {
    try {
      const response = await axios.get(`${server}monitor/bounds`, {
        params: { id },
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  UpdateBounds: async (mobileID, upperBound, lowerBound, tolerance) => {
    try {
      const response = await axios.post(`${server}monitor/bounds/update`, {
        mobileID: mobileID,
        upperBound: upperBound,
        lowerBound: lowerBound,
        tolerance: tolerance,
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetMakeUp: async (id) => {
    try {
      const response = await axios.get(`${server}monitor/makeup`, {
        params: { id },
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  UpdateMakeUp: async (mobileID, makeUp) => {
    try {
      const response = await axios.post(`${server}monitor/makeup/update`, {
        mobileID: mobileID,
        makeUp: makeUp ? 1 : 0,
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  RestartServer: async (mobileID) => {
    try {
      const response = await axios.post(`${server}monitor/restart_server`, {
        mobileID: mobileID,
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  }
};
